import { MenuItemType } from '@utils/types'
import { DownloadLink, WContainer } from '../../atoms'
import { Download } from '../../icons'
import styles from './BannerCertificazioni.module.sass'

interface Props {
  item: MenuItemType
  className?: string
  theme?: 'white'
}

const BannerCertificazioni = (props: Props) => {
  const { item = undefined, className = '', theme = 'white' } = props

  return item?.children?.length ? (
    <div className={`${styles.root} ${className} ${styles[`root--${theme}`]}`}>
      <WContainer className={`${styles.layout}`}>
        {item?.name && <h2 className={styles.title}>{item.name}</h2>}
        <div className={styles.main}>
          {item?.children.length > 0 &&
            item?.children.map((i) => <DownloadLink item={i} className={styles.link} />)}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default BannerCertificazioni
